import Toaster from "common/Toaster";
import s3BucketApiCallWrapper from "./S3BucketApi";

export const CURRENCY = "AED";
export const detailSideDrawerWidth = 250;
export const STATUS_COLOR = {
  expired: "#B71C19",
  active: "#19806A",
  inactive: "#B76D00",
  pending: "#000000",
  "not-delivered": "#000000",
  waiting: "#000000",
  discarded: "#000000",
  "in-progress": "#B76D00",
  "partially-delivered": "#fff",
  delivered: "#19806A",
  cancelled: "#B71C19",
  approved: "#19806A",
  booked: "#19806A",
  accepted: "#000000",
  completed: "#fff",
  confirmed: "#fff",
  rejected: "#B71C19",
  canceled: "#B71C19",
};

export const STATUS_BACKGROUND_COLOR = {
  expired: "#F9DED9",
  active: "#DBEBE4",
  inactive: "#F8EAD8",
  pending: "#0000001a",
  "not-delivered": "#0000001a",
  waiting: "#0000001a",
  discarded: "#0000001a",
  "in-progress": "#F8EAD8",
  "partially-delivered": "#81c784",
  delivered: "#DBEBE4",
  cancelled: "#F9DED9",
  approved: "#DBEBE4",
  booked: "#DBEBE4",
  accepted: "#ffeb3b",
  completed: "#19806A",
  confirmed: "#19806A",
  rejected: "#F9DED9",
  canceled: "#F9DED9",
};
export const REP_TYPES = [
  {
    display: "Count",
    key: "count",
  },
  {
    display: "Time",
    key: "time",
  },
];

export const FILTER_SAVE_KEY_NAME = {
  members: "members",
  employees: "employees",
};

export const BASE_DIR =
  process.env.REACT_APP_BUILD_TYPE === "DEV" ? "stageGym/" : "supergym/";

export const ACTIVE_INACTIVE_STATUS = [
  {
    display: "Active",
    key: true,
  },
  {
    display: "InActive",
    key: false,
  },
];
